import { match } from 'path-to-regexp'

import { carryNoApp } from '@app/utils/noApp'

import type { LocationInit, RouteDescriptorRedirect } from './types'
import { createLocation } from './utils'

/**
 * Every route-level redirect goes through here, so this is where the app's declined-link marker
 * is kept: a target built from scratch would look unmarked and be claimed again.
 */
export const createRedirectLocation = (redirect: RouteDescriptorRedirect, location: LocationInit) => {
  const target = resolve(redirect, location)
  return { ...target, search: carryNoApp(location.search, target.search) }
}

const resolve = (redirect: RouteDescriptorRedirect, location: LocationInit) => {
  const to = redirect.redirect.location
  const m = match(redirect.path)(location.pathname)
  const params = m ? (m.params as Record<string, string>) : {}
  if (typeof to === 'string') {
    let path = to
    for (const [key, value] of Object.entries(params)) {
      path = path.replaceAll(`:${key}`, value)
    }
    return { ...location, pathname: path }
  }
  if (typeof to === 'function') {
    const res = to(createLocation(location))
    if (typeof res === 'string') {
      return { ...location, pathname: res }
    }
    return res
  }
  return to
}
